import React from 'react';
import {FormHelperText, type FormHelperTextProps} from '@mui/material';

export interface ErrorFieldProps extends Omit<FormHelperTextProps, 'error'> {
	error?: string;
}

export const ErrorField: React.FunctionComponent<ErrorFieldProps> = ({
	error,
	...props
}) => {
	if (!error) return null;

	return (
		<FormHelperText data-testid="form-input-error-field" {...props} error>
			{error}
		</FormHelperText>
	);
};

export default ErrorField;
